import { render, staticRenderFns } from "./myMessage.vue?vue&type=template&id=12b4729c&scoped=true&"
import script from "./myMessage.vue?vue&type=script&lang=js&"
export * from "./myMessage.vue?vue&type=script&lang=js&"
import style0 from "./myMessage.vue?vue&type=style&index=0&id=12b4729c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b4729c",
  null
  
)

export default component.exports